import { useEffect } from "react";

export const SITE_NAME = "instrukt";

/** Build "{a} · {b} · instrukt" from the non-empty parts (`docs/design/ia.md` §6). */
export function pageTitle(...parts: Array<string | null | undefined | false>): string {
  const clean = parts.filter((p): p is string => typeof p === "string" && p.trim() !== "");
  return [...clean, SITE_NAME].join(" · ");
}

/** Set `document.title` for the mounted screen. */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title;
  }, [title]);
}
